__turbopack_context__.v({
  "bodyCopy": "partnerSubscription-module-scss-module__Us-97W__bodyCopy",
  "chatLinkStyles": "partnerSubscription-module-scss-module__Us-97W__chatLinkStyles",
  "ctaSection": "partnerSubscription-module-scss-module__Us-97W__ctaSection",
  "textGroupSection": "partnerSubscription-module-scss-module__Us-97W__textGroupSection",
});
